import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { Button, Input } from 'hljd'
import style from './style.module.less'
import Tab from './Tab'
import Table from './Table'
import { observer } from 'mobx-react'
import Store from './store'
import { hashHistory, Link } from 'react-router'
import {
  JIAMENG_GOODS_PATH,
  PROPERTY_OBJ,
  STORE_PUBLISH_MEAL_PATH
} from '@constant'
const store = new Store()

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    store.setStoreData('property_id', props.params.id)
  }
  onAddClick = () => {
    hashHistory.push(
      `${STORE_PUBLISH_MEAL_PATH}?propertyId=${this.props.params.id}`
    )
  }

  componentWillUnmount() {
    store.reset()
  }
  render() {
    let name = PROPERTY_OBJ[this.props.params.id]

    const header = [<Link to={JIAMENG_GOODS_PATH}>商品管理</Link>, name]
    return (
      <HeaderView
        title={name}
        header={header}
        extra={
          <div>
            <Button style={{ marginRight: '10px' }} onClick={this.onAddClick}>
              添加自有商品
            </Button>
            <Button
              type="primary"
              onClick={() =>
                hashHistory.push(
                  '/localMerchant/jiaMengGoods/weddingPhoto/add/' +
                    this.props.params.id
                )
              }
            >
              添加直供商品
            </Button>
          </div>
        }
      >
        <div className={style.weddingPhotoGoodsWrap}>
          <div className="search-box">
            <Input
              placeholder="请输入套餐名称"
              style={{ width: '240px', marginRight: '20px' }}
              onChange={e => store.setStoreData('title', e.target.value)}
            />
            <Button type="primary" onClick={store.search}>
              搜索
            </Button>
          </div>
          <Tab store={store} />
          <Table store={store} />
        </div>
      </HeaderView>
    )
  }
}
